import Vue from 'vue'
import VueInfiniteLoading from 'vue-infinite-loading'

Vue.use(VueInfiniteLoading)
